import { createFileRoute, Navigate } from '@tanstack/react-router'

import { NotFoundPage } from '@/shared/components/common/NotFoundPage'

export const Route = createFileRoute('/_app/')({
	notFoundComponent: () => <NotFoundPage />,
	component: () => <Navigate to='/p/og' replace />,
})
